var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTaskAnimalKill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.365 18.084a.426.426 0 0 0-.429-.424h-2.223V9.62H18V6.233h-4.286V2h-3.428v4.233H6v3.386h4.286v8.041H8.063a.426.426 0 0 0-.43.424v1.059H6V22h12v-2.858h-1.635z"
})));
export default SvgTaskAnimalKill;